



























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
@Component({})
export default class ShowOnClickComponent extends Vue {
    @Prop() public text: string;
    @Prop({default: true}) public pre: boolean;
    public show: boolean = false;
    public toggleShow() {
        this.show = !this.show;
        console.log(this.show);
    }
}
